import { type InitOptions } from 'i18next';

export const i18nConfig: InitOptions = {
    fallbackLng: 'fr',
    postProcess: 'displayKeys',
    appendNamespaceToMissingKey: true,
    interpolation: {
        escapeValue: false
    },
    keySeparator: '.',
    returnNull: false,
    react: {
        transSupportBasicHtmlNodes: true,
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b', 'ul', 'ol', 'li', 'a', 'br', 'span'],
        useSuspense: false
    }
};
